import { getSessionToken } from '../utils/sessionToken';
import { Config } from './apiRoutes';

// Authenticates requests against the Pack Perfect worker - the API
// Gateway authorizer validates the App Bridge session JWT sent in the
// `payload` header.
export async function authHeaders() {
  return { ...Config.headers, payload: await getSessionToken() };
}

export function apiErrorMessage(error, fallback) {
  return error.response?.data?.error?.message || error.response?.data?.message || fallback;
}
